// Utils
import { clearOptionAction } from './clearOptionAction';
/**
 * Remove the selected value and tooltip from the screen
 *
 * @param {() => void} onDropdownOptionCleared
 * @param {Dispatch<DropdownReducerAction>} dispatch
 * @param {() => void} closeTooltip
 * @param {() => void} focusOnTheDropdownInput
 */
export var handleClearSelectedValue = function (onDropdownOptionCleared, dispatch, closeTooltip, focusOnTheDropdownInput) {
    return function () {
        dispatch(clearOptionAction);
        closeTooltip();
        focusOnTheDropdownInput();
        onDropdownOptionCleared();
    };
};
//# sourceMappingURL=handleClearSelectedValue.js.map